// @ts-nocheck
import {
  Grid,
  TextField,
  Typography,
  Button
} from "@material-ui/core";
import axios from "axios";
import { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { Badge} from "@mui/material";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { SERVER_IP, PrimaryColor } from "../../variables";
import { useNavigate, } from "react-router-dom";
import { Sidebar } from "../Sidebar";
import CircularProgress from '@mui/material/CircularProgress';
import { base64Converter, dateFormat, getCurrentUserID, getDateTime, inputFieldVariant, isLoggedUserStaff, removeBadgeStyle } from "../../utils";
import { useForm, Controller } from 'react-hook-form';
import pdfIcon from '../../assert/pdf_icon.png'
import { Container, Row, Col } from 'react-bootstrap'
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";

export const AddProgressiveClaim = () => {

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const [reportDate, setReportDate] = useState<any>(null);
  const [uploadedFiles, setUploadedFiles] = useState<Array<any>>([]);

  const isStaff = isLoggedUserStaff()

  const { handleSubmit, control} = useForm();


  const createProgressiveClaim = async (data) => {
    if (!!!uploadedFiles.length) {
      toast.error("Report Not Uploaded")
      return
    }
    if (!!!reportDate) {
      toast.error("Select a Date")
      return
    }

    let files = await uploadedFiles?.map(async d => {
      let t = await base64Converter(d)
      return {
        data: t,
        fileName: d.name
      }
    })

    Promise.all(files).then(function (results) {
      let temp = {
        ...data,
        ReportedDate: dateFormat(reportDate, "YYYY-MM-DD"),
        ProgressiveReportFile: results,
        CreatedBy: getCurrentUserID()
      }
      console.log(temp)
      setLoading(true)
      axios
        .post(
          `${SERVER_IP}progressiveClaimReport/save`,
          temp
        )
        .then((res) => {
          toast.success("Claim Successfully Added");
        }).then(() => navigate("/ProgressiveClaim"))
        .catch((res) => {
          toast.error("Couldn't Add Claim");
        }).finally(() => setLoading(false))
    })
  };

  const removeUploadedFile = (file) => {
    let temp = uploadedFiles.filter(f => f.name !== file.name)
    setUploadedFiles(temp)
    if(temp.length === 0){
      document.getElementById("ProgressiveClaimURL").value = ''
    }
  }

  return (

    <>
      <div style={{ marginTop: 80, display: 'flex' }}>
        <Sidebar />
        <Grid container spacing={1} style={{ padding: '10px 30px 10px 30px' }}>
          <Grid container spacing={3} style={{ margin: '10px auto', borderRadius: '10px', border: `2px solid ${PrimaryColor}` }}>
            <form style={{ width: '100%' }} onSubmit={handleSubmit(createProgressiveClaim)}>
              <Grid container>
                <Grid item xs={12}>
                  <Typography style={{ backgroundColor: PrimaryColor, color: 'white' }} variant="h6" gutterBottom>
                    <AccountCircleIcon style={{ margin: 'auto 5px' }} />
                    {"Add Progressive Claim"}
                  </Typography>
                </Grid>

                <Grid container spacing={3} style={{ margin: 'auto' }}>


                  <Grid item xs={12} sm={6}>

                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="Report Date"
                        inputFormat="dd/MM/yyyy"
                        value={reportDate}
                        onChange={(newValue) => {
                          setReportDate(newValue)
                        }}
                        renderInput={(params) => <TextField
                          variant="standard"
                          id="ReportDate"
                          name="ReportDate"
                          fullWidth
                          {...params} />
                        }
                      />
                    </LocalizationProvider>

                  </Grid>

                  <Grid item xs={12} sm={6}>
                    
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography>Claim (PDF Only)</Typography>
                    <input
                      type="file"
                      multiple
                      accept={'.pdf'}
                      id="ProgressiveClaimURL"
                      name="ProgressiveClaimURL"
                      onChange={async (e) => {
                        if (!!e.target.files?.length) {
                          let pendingFiles = []
                          let existingFiles = uploadedFiles.map(f => f.name)
                          var inp = document.getElementById('ProgressiveClaimURL');
                          for (var i = 0; i < inp.files.length; ++i) {
                            if (!existingFiles.includes(inp.files.item(i).name))
                              pendingFiles.push(inp.files.item(i))
                          }
                          if (pendingFiles.length === 0) {
                            toast.error("File with same name already added")
                            e.stopPropagation();
                            return
                          }
                          setUploadedFiles([...uploadedFiles, ...pendingFiles])
                        }
                      }}
                    />
                  </Grid>

                  <Container>
                    <Row>

                      {
                        uploadedFiles?.map((d, index) => {

                          if (d?.type?.includes("pdf")) {
                            return <Col key={index} sm>
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <Grid item xs={12}>
                                  <img
                                    title="Click To View"
                                    src={pdfIcon}
                                    style={{ width: 'auto', height: '150px', cursor: 'pointer' }}
                                    onClick={() => {
                                      window.open(URL.createObjectURL(d))
                                    }}
                                    alt="preview"
                                  />
                                  <Badge style={removeBadgeStyle} title="Remove" onClick={() => removeUploadedFile(d)} color="error" badgeContent="X">
                                  </Badge>
                                </Grid>
                                <strong>File Name : {d.name}</strong>
                              </div>
                            </Col>
                          }
                        })
                      }

                    </Row>
                  </Container>
                </Grid>
              </Grid>

              <Grid container style={{ marginBottom: '10px' }}>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  style={{ textAlign: "center" }}
                >
                  <Button
                    disabled={loading}
                    color="primary"
                    size="small"
                    variant="contained"
                    type="submit"
                  >
                    {loading && <CircularProgress size={20} style={{ marginRight: '10px' }} />}
                    {"Create Claim"}
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  style={{ textAlign: "center" }}
                >
                  <Button
                    color="secondary"
                    size="small"
                    variant="contained"
                    onClick={(e) => navigate("/ProgressiveClaim")}>
                    Cancel
                  </Button>
                </Grid>

              </Grid>
            </form>

            <ToastContainer />
          </Grid>
        </Grid>

      </div>
    </>

  );
};
